import styled from "@emotion/styled";
import { useEffect, useState } from "react";

const Loader = styled.div`
  position: relative;
  width: 100%;
  max-width: 360px;
  margin: 32px 16px 16px 16px;
  border-radius: 4px;
  height: 4px;
  background: #b6b6b6;
  overflow: hidden;
  :after {
    content: "jj";
    position: absolute;
    width: 30%;
    height: 100%;
    background: #46a163;
    border-radius: 4px;
    animation: load 1s linear infinite;
    transform-origin: 0 0;
  }
  @keyframes load {
    0% {
      width: 30%;
      transform: translateX(-300%);
    }
    50% {
      width: 30%;
      transform: translateX(0%);
    }
    100% {
      width: 30%;
      transform: translateX(200%);
    }
  }
`;

const UpdateAppButton = styled.button`
  background: #e91e63;
  color: #fff;
  border: none;
  outline: none;
  border-radius: 50px;
  padding: 10px;
  font-size: 14px;
  font-weight: 500;
  width: 100%;
  max-width: 360px;
  margin-top: 16px;
  appearance: none;
`;

export const ServiceWorkerUpdateAvailable = () => {
  const [updateAvailable, setUpdateAvailable] = useState("IDLE");
  useEffect(() => {
    if (updateAvailable !== "LOADING") return;
    const timerToken = setTimeout(() => {
      window.location.reload();
    }, 2000);
    return () => clearTimeout(timerToken);
  }, [updateAvailable]);
  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 99999,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        textAlign: "center",
      }}
      role="dialog"
      aria-hidden="true"
      data-noindex="true"
    >
      <div
        style={{
          position: "absolute",
          bottom: 0,
          background: "#fff",
          left: "0",
          borderRadius: "8px",
          right: "0",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          padding: "16px 16px 40px 16px",
        }}
      >
        <h1
          style={{
            fontSize: "20px",
            margin: 0,
            padding: 0,
            marginTop: "24px",
            fontWeight: 500,
          }}
          aria-hidden="true"
          data-noindex="true"
        >
          New Update is Here!
        </h1>
        <p
          style={{
            fontSize: "14px",
            margin: 0,
            padding: 0,
            marginTop: "8px",
            fontWeight: 300,
          }}
        >
          {updateAvailable === "LOADING"
            ? "Updating your app..."
            : "To use this app you need to update to the latest version."}
        </p>
        {updateAvailable === "LOADING" && <Loader />}
        <p
          style={{
            fontSize: "10px",
            margin: 0,
            padding: 0,
            fontWeight: 300,
          }}
        >
          Be patient, it might take few seconds to redirect you to your Wishlink
          Home
        </p>
        {updateAvailable === "IDLE" && (
          <UpdateAppButton onClick={() => setUpdateAvailable("LOADING")}>
            Update
          </UpdateAppButton>
        )}
      </div>
    </div>
  );
};
